import { SeoLandingLayout, SeoLandingPageData } from '../../../components/SeoLandingLayout';

const data: SeoLandingPageData = {
  seo: {
    title: 'Suivi de trésorerie entreprise : méthode et outils efficaces | Trezoone',
    description: 'Mettez en place un suivi de trésorerie efficace pour votre entreprise. Méthode pas à pas, outils recommandés, indicateurs clés.',
    canonical: '/suivi-tresorerie-entreprise',
    keywords: 'suivi trésorerie entreprise, suivi de trésorerie, suivre sa trésorerie, tableau suivi trésorerie, indicateurs trésorerie',
  },
  hero: {
    tag: 'Suivi trésorerie entreprise',
    title: 'Suivre sa trésorerie, c\'est regarder les bons chiffres — au bon moment.',
    subtitle: 'Le suivi de trésorerie ne se résume pas à regarder le solde de son compte. Voici les indicateurs qui comptent vraiment et comment les surveiller.',
    ctaLabel: 'Commencer mon suivi',
  },
  pilierLink: { label: 'Guide gestion de trésorerie', href: '/gestion-tresorerie' },
  sections: [
    {
      type: 'explain',
      title: 'Les 5 indicateurs clés du suivi de trésorerie',
      content: 'Un bon suivi de trésorerie s\'appuie sur 5 indicateurs fondamentaux :',
      items: [
        '1. Solde disponible réel : ce qui est vraiment sur le compte (pas les provisions)',
        '2. Créances clients en cours : ce que vous attendez d\'encaisser et quand',
        '3. Dettes fournisseurs : ce que vous devez payer et à quelle échéance',
        '4. Solde prévisionnel à 30-60-90 jours : où vous serez si tout se passe comme prévu',
        '5. Temps de survie financière : combien de semaines vous tenez sans nouvelle recette',
      ],
    },
    {
      type: 'example',
      title: 'Exemple de tableau de bord de suivi trésorerie',
      content: 'Voici ce qu\'un tableau de bord de suivi trésorerie efficace affiche en temps réel :',
      items: [
        'Solde bancaire actuel : 18 500 €',
        'Créances à encaisser (30j) : +32 000 € (dont 2 factures en retard pour 8 000 €)',
        'Décaissements prévus (30j) : -24 500 € (salaires + charges + fournisseurs)',
        'Solde prévisionnel à 30j : +26 000 €',
        'Temps de survie à charges constantes : 6,2 semaines',
        'Alerte : 2 factures clients en retard → relance à déclencher',
      ],
    },
    {
      type: 'midcta',
      title: 'Votre tableau de bord de trésorerie, mis à jour en temps réel — sans ressaisie manuelle',
      content: 'Trezoone connecte vos données bancaires et construit automatiquement vos 5 indicateurs clés de trésorerie.',
    },
    {
      type: 'solution',
      title: 'Trezoone construit ce tableau de bord automatiquement',
      content: 'Plus besoin de consolider manuellement vos données. Trezoone fait le suivi à votre place.',
      items: [
        'Tableau de bord temps réel mis à jour à chaque import bancaire',
        'Indicateurs de trésorerie calculés automatiquement',
        'Alertes configurables sur chaque indicateur',
        'Historique des 12 derniers mois pour identifier les tendances',
        'Comparaison prévisionnel vs réalisé automatisée',
      ],
    },
    {
      type: 'cluster',
      title: 'Outils pour piloter votre trésorerie d\'entreprise',
      links: [
        { label: 'Gestion trésorerie', href: '/gestion-tresorerie' },
        { label: 'Plan de trésorerie', href: '/plan-tresorerie' },
        { label: 'Alerte trésorerie', href: '/alerte-tresorerie' },
        { label: 'Prévision trésorerie', href: '/prevision-tresorerie' },
        { label: 'Cash flow entreprise', href: '/cash-flow-entreprise' },
        { label: 'BFR et trésorerie', href: '/bfr-tresorerie' },
        { label: 'Logiciel trésorerie entreprise', href: '/logiciel-tresorerie-entreprise' },
        { label: 'Excel vs logiciel trésorerie', href: '/excel-vs-logiciel-tresorerie' },
      ],
    },
    {
      type: 'cta',
      title: 'Mettez en place votre suivi de trésorerie aujourd\'hui',
      content: 'Essai Trezoone 14 jours gratuit. Tableau de bord opérationnel en 30 minutes.',
    },
  ],
  relatedLinks: [
    { label: 'Gestion trésorerie', href: '/gestion-tresorerie' },
    { label: 'Plan de trésorerie', href: '/plan-tresorerie' },
    { label: 'Alerte trésorerie', href: '/alerte-tresorerie' },
    { label: 'Prévision trésorerie', href: '/prevision-tresorerie' },
    { label: 'Cash flow entreprise', href: '/cash-flow-entreprise' },
    { label: 'BFR et trésorerie', href: '/bfr-tresorerie' },
    { label: 'Logiciel trésorerie entreprise', href: '/logiciel-tresorerie-entreprise' },
    { label: 'Excel vs logiciel trésorerie', href: '/excel-vs-logiciel-tresorerie' },
  ],
};

interface Props { onNavigate?: (p: string) => void; onSignIn?: () => void; onSignUp?: () => void; }
export default function SuiviTresorerieEntrepriseExcelPage({ onNavigate, onSignIn, onSignUp }: Props) {
  return <SeoLandingLayout data={data} onNavigate={onNavigate} onSignIn={onSignIn} onSignUp={onSignUp} />;
}
